<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="384"
    height="100"
    viewBox="-20 0 384 100"
    style="overflow: visible"
  >
    <!-- background line -->
    <line
      x1="30"
      y1="30"
      x2="313"
      y2="30"
      stroke="#B3B3B3"
      stroke-width="2"
      stroke-linecap="round"
    />

    <!-- active line -->
    <line
      x1="30"
      y1="30"
      :x2="activeLineX"
      y2="30"
      stroke="#F58332"
      stroke-width="2"
      stroke-linecap="round"
    />

    <!-- STEP 1 -->
    <g>
      <circle
        cx="30"
        cy="30"
        r="24"
        :fill="value >= 1 ? '#F58332' : '#B3B3B3'"
        stroke-width="0.5"
      />
      <circle
        cx="30"
        cy="30"
        r="19"
        fill="none"
        stroke="#ffffff"
        stroke-width="3"
      />
      <image :href="icons.sendFile" x="20" y="20" width="22" height="22" />
    </g>

    <!-- STEP 2 -->
    <g>
      <circle
        cx="124"
        cy="30"
        r="24"
        :fill="value >= 2 ? '#F58332' : '#B3B3B3'"
      />
      <circle
        cx="124"
        cy="30"
        r="19"
        fill="none"
        stroke="#ffffff"
        stroke-width="3"
      />
      <image :href="icons.search" x="113" y="20" width="22" height="22" />
    </g>

    <!-- STEP 3 -->
    <g>
      <circle
        cx="219"
        cy="30"
        r="24"
        :fill="value >= 3 ? '#F58332' : '#B3B3B3'"
      />
      <circle
        cx="219"
        cy="30"
        r="19"
        fill="none"
        stroke="#ffffff"
        stroke-width="3"
      />
      <image :href="icons.hourglass" x="208" y="20" width="22" height="22" />
    </g>

    <!-- STEP 4 -->
    <g>
      <circle
        cx="313"
        cy="30"
        r="24"
        :fill="value >= 4 ? '#F58332' : '#B3B3B3'"
      />
      <circle
        cx="313"
        cy="30"
        r="19"
        fill="none"
        stroke="#ffffff"
        stroke-width="3"
      />
      <image :href="icons.phone" x="303" y="20" width="22"  height="22" />
    </g>

    <!-- TEXT STEP 1 -->
    <foreignObject x="-20" y="58" width="100" height="40">
      <div
        xmlns="http://www.w3.org/1999/xhtml"
        class="step-text"
        :style="{ color: value >= 1 ? '#000' : '#BDBDBD' }"
      >
        บันทึกเอกสาร
      </div>
    </foreignObject>

    <!-- TEXT STEP 2 -->
    <foreignObject x="74" y="58" width="100" height="40">
      <div
        xmlns="http://www.w3.org/1999/xhtml"
        class="step-text"
        :style="{ color: value >= 2 ? '#000' : '#BDBDBD' }"
      >
        ตรวจสอบ
      </div>
    </foreignObject>

    <!-- TEXT STEP 3 -->
    <foreignObject x="169" y="58" width="100" height="40">
      <div
        xmlns="http://www.w3.org/1999/xhtml"
        class="step-text"
        :style="{ color: value >= 3 ? '#000' : '#BDBDBD' }"
      >
        ประมวลผล
      </div>
    </foreignObject>

    <!-- TEXT STEP 4 -->
    <foreignObject x="263" y="58" width="100" height="40">
      <div
        xmlns="http://www.w3.org/1999/xhtml"
        class="step-text"
        :style="{ color: value >= 4 ? '#000' : '#BDBDBD' }"
      >
        แจ้งผลพิจารณา
      </div>
    </foreignObject>
  </svg>
</template>

<script>
import sendFileIcon from '@/assets/images/rentalStatusIcon/send-file.png';
import searchIcon from '@/assets/images/rentalStatusIcon/search.png';
import hourglassIcon from '@/assets/images/rentalStatusIcon/hourglass.png';
import phoneIcon from '@/assets/images/rentalStatusIcon/phone.png';

export default {
  props: {
    value: {
      required: true,
      type: Number
    }
  },
  data() {
    return {
      icons: {
        sendFile: sendFileIcon,
        search: searchIcon,
        hourglass: hourglassIcon,
        phone: phoneIcon
      }
    };
  },
  computed: {
    activeLineX() {
      switch (this.value) {
        case 1:
          return 30;
        case 2:
          return 124;
        case 3:
          return 219;
        case 4:
        case 5:
          return 313;
        default:
          return 30;
      }
    }
  }
};
</script>

<style scoped>
.step-text {
  font-size: 12px;
  font-family: Kanit-Regular, Kanit, sans-serif;
  font-weight: 400;
  text-align: center;
  line-height: 14px;
white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  height: 100%;
}
</style>